<mat-card appearance="outlined" class="step-card">
  <mat-card-header>
    <mat-card-title>
      {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.CALENDAR_SLUG.TITLE_V2' | translate }}
    </mat-card-title>
  </mat-card-header>
  <div *ngIf="loading$ | async">
    <div class="stencil-shimmer col col-xs-4 calendar-slug-shimmer"></div>
    <div class="stencil-shimmer col col-xs-4 calendar-slug-shimmer"></div>
  </div>
  <mat-card-content>
    <div *ngIf="(loading$ | async) === false">
      <div>
        <div class="subtitle" *ngIf="description$ | async as description">{{ description }}</div>
        <glxy-form-field [prefixText]="linkPrefix$ | async" [bottomSpacing]="'none'">
          <input [formControl]="slugFormControl" name="slug" />
          <button *ngIf="slugChanged$$ | async" mat-icon-button matSuffix (click)="revertSlug()">
            <mat-icon>undo</mat-icon>
          </button>
          <glxy-error *ngIf="slugFormControl.invalid">
            <ng-container
              *ngIf="slugFormControl.hasError('taken') || slugFormControl.hasError('pattern'); else genericError"
            >
              <ng-container *ngIf="slugFormControl.hasError('taken')">
                {{ slugFormControl.errors.taken }}
              </ng-container>
              <ng-container *ngIf="slugFormControl.hasError('pattern')">
                {{ slugFormControl.errors.pattern }}
              </ng-container>
            </ng-container>
            <ng-template #genericError>
              {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.CALENDAR_SLUG.VALIDATION.GENERIC_ERROR' | translate }}
            </ng-template>
          </glxy-error>
        </glxy-form-field>
      </div>
    </div>

    <div class="form-row form-actions">
      <button
        *ngIf="(isSaving$$ | async) === false"
        [disabled]="
          (loading$ | async) ||
          slugFormControl.invalid ||
          (disableButtonIfValueUnchanged && this.originalSlug === slugFormControl.value)
        "
        (click)="setSlug(slugFormControl.value)"
        mat-raised-button
        color="primary"
        type="submit"
        data-testid="slug-submit"
      >
        {{ buttonLabel }}
      </button>
      <div class="spinner-container" *ngIf="isSaving$$ | async">
        <mat-spinner [diameter]="20"></mat-spinner>
      </div>
    </div>
  </mat-card-content>
</mat-card>
